import { MiniCartProps } from "@bluebottlecoffee/design-system";
import { Cart as CartSchema } from "../sanity-schema";
import { CartSchemaProps, toCartProps } from "./cart";

export type MiniCartSchemaProps = Omit<MiniCartProps, "cartProps"> & {
  cartCopy: CartSchemaProps;
};

export function toMiniCartProps(
  data: CartSchema,
  region: string,
  lang: string,
): MiniCartSchemaProps {
  return {
    bgColor: data.dialog.bgColor,
    cartCopy: toCartProps(data, region, lang),
    heading: data.dialog.heading[lang],
  };
}
